import axios from 'axios'


//获取采摘称重明细
export function getPickingWeighDetailList (pickingWeighId) {
  return axios.get(`/manage/picking-batch-weigh/queryPickingWeighDetail/${pickingWeighId}`)
}

